import { StudentAssessmentType } from "../../../types/Assessment";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { STUDENT_ASSESSMENTS } from "../../../utils/constants";

export const getStudentsAssessments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
        ...(data?.IdAssessment ? { IdAssessment: data.IdAssessment } : {}),
    });
    const url = `${STUDENT_ASSESSMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentAssessmentType>>(url)
};
export const getMyStudentAssessments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
    });
    const url = `${STUDENT_ASSESSMENTS}/student/GetMyAssessments?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentAssessmentType>>(url)
};